import { render, staticRenderFns } from "./ListArticle.vue?vue&type=template&id=998a55e4&scoped=true&"
import script from "./ListArticle.vue?vue&type=script&lang=ts&"
export * from "./ListArticle.vue?vue&type=script&lang=ts&"
import style0 from "./ListArticle.vue?vue&type=style&index=0&id=998a55e4&lang=less&scoped=true&"
import style1 from "./ListArticle.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "998a55e4",
  null
  
)

export default component.exports